"use strict";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var React = require('react');

var PropTypes = require('prop-types');

var PrintJob = require('../../PrintJob');

var Space = require('./Space');

function ProductDetailsWrapper(props) {
  var printJob = props.printJob,
      filterFunction = props.filterFunction,
      RenderComponent = props.RenderComponent,
      children = props.children;
  var nodes = [];
  printJob.products.forEach(function (product, p) {
    product.subcomponents().filter(filterFunction).map(function (component, c) {
      return /*#__PURE__*/React.createElement(RenderComponent, _extends({
        key: p + c,
        component: component,
        product: product
      }, props));
    }).forEach(function (node, index) {
      nodes.push(node);
      nodes.push( /*#__PURE__*/React.createElement(Space, {
        n: 1,
        key: index
      }));
    });
  });

  if (nodes.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", null, nodes, children);
}

module.exports = ProductDetailsWrapper;
ProductDetailsWrapper.propTypes = {
  printJob: PropTypes.instanceOf(PrintJob),
  filterFunction: PropTypes.func.isRequired,
  RenderComponent: PropTypes.func.isRequired,
  componentSettings: PropTypes.any.isRequired,
  options: PropTypes.any.isRequired,
  children: PropTypes.any
};